import { render, staticRenderFns } from "./business_add.vue?vue&type=template&id=ff681edc&scoped=true&"
import script from "./business_add.vue?vue&type=script&lang=js&"
export * from "./business_add.vue?vue&type=script&lang=js&"
import style0 from "./business_add.vue?vue&type=style&index=0&id=ff681edc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff681edc",
  null
  
)

export default component.exports